// ##############################
// // // ValidationForms view styles
// #############################

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const validationFormsStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle: {
    ...cardTitle,
    color: "#FFFFFF"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  formCategory: {
    marginBottom: "0",
    color: "#999999",
    fontSize: "14px",
    padding: "10px 0 10px"
  },
  center: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center"
  },
  registerButton: {
    float: "right!important",
  },
  btnDefault:{
      float: "right!important",
    border:'1px solid #7e7573',
    color:'#7e7573',
    background: 'transparent',
    boxShadow:'none',
    '&:hover': {
      background:'#7e7573',
      color: '#ffffff)',
      boxShadow:'none',

    }
  },
  btnAddProduct:{
    background: 'transparent',
    color: '#319ebb',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor:'transparent',
      color: '#319ebb',
      textDecoration:'underline',
      boxShadow:'none',
    }
  }
};

export default validationFormsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx